<template>
  <span style="font-size: xx-small" :title="needTruncate?value:''">{{ truncatedValue }}</span>
</template>

<script>
export default {
  props: {
    value: {},
    maxLength: {
      default: 30,
    },
  },
  computed: {
    needTruncate() {
      if (
          typeof this.value == typeof "" &&
          this.value.length > this.maxLength
      ) {
        return true;
      }
    },
    truncatedValue() {
      if (this.needTruncate) return this.value.substr(0, this.maxLength) + "...";
      return this.value;
    },
  },
};
</script>

<style>
</style>